export default __webpack_public_path__ + "static/media/accessmgmt.5957db20.svg";